import api from './api';

const financeReconciliationService = {
    getMerchantOverview: async (id, params) => {
        try {
            const response = await api.get(`/finance-reconciliation/merchants/${id}/overview`, { params });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    getReports: async (params) => {
        try {
            const response = await api.get('/finance-reconciliation/reports', { params });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    createReport: async (data) => {
        try {
            const response = await api.post('/finance-reconciliation/reports', data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    updateReport: async (id, data) => {
        try {
            const response = await api.put(`/finance-reconciliation/reports/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    deleteReport: async (id) => {
        try {
            const response = await api.delete(`/finance-reconciliation/reports/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    getReportById: async (id) => {
        try {
            const response = await api.get(`/finance-reconciliation/reports/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    getReportRows: async (id) => {
        try {
            const response = await api.get(`/finance-reconciliation/reports/${id}/rows`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    fetchProviderReport: async (id, data) => {
        try {
            const response = await api.post(`/finance-reconciliation/reports/${id}/provider-report`, data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    saveReportRows: async (id, data) => {
        try {
            const response = await api.post(`/finance-reconciliation/reports/${id}/rows`, data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    submitReport: async (id) => {
        try {
            const response = await api.post(`/finance-reconciliation/reports/${id}/submit`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    decideReport: async (id, data) => {
        try {
            const response = await api.post(`/finance-reconciliation/reports/${id}/decision`, data);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    getMerchants: async (params) => {
        try {
            const response = await api.get('/finance-reconciliation/merchants', { params });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    }
};

export default financeReconciliationService;
